var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright text-center"},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('img',{staticClass:"img-fluid logo-footer",attrs:{"src":require("@/assets/imgs/logo_atlantis.png"),"alt":"","srcset":""}})]),_vm._v(".\n    ")])])])
}]

export { render, staticRenderFns }